const drawOnCanvas = () =>{
    if(document.querySelector('.stoof-car-layout-wrapper')){
        const canvasContainer = document.querySelectorAll('.stoof-car-layout-wrapper');
        const drawLines = (canvas) => {
            let ctx = canvas.getContext('2d');
            let linesString = canvas.getAttribute('data-lines');
            let coordsArray = JSON.parse(linesString);
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
            ctx.strokeStyle = "#DD042D";
            ctx.lineWidth = 1;
            coordsArray.paths.forEach(el => {
                if(el[0] === 'mt'){
                    ctx.moveTo(cX(canvas, el[1]*1), cY(canvas, el[2]*1));
                }else{
                    ctx.lineTo(cX(canvas, el[1]*1), cY(canvas, el[2]*1));
                }
            })

            ctx.stroke();

        }
        const cX = (canvas, xCoord) => {
            return canvas.width / 100 * xCoord;
        }
        const cY = (canvas, yCoord) => {
            return canvas.height / 100 * yCoord;
        }

        canvasContainer.forEach(canvasContainer => {
            let can = canvasContainer.querySelector('.stoof-car-layout-canvas');
            drawLines(can);
        })
    }
}
export default drawOnCanvas;